import { AXIOS } from "../config/axios.config";

class PkgCategoryService {
  async fetchCategories(query: string) {
    return await AXIOS.get(`/pkgDestinationCategory/getAll${query}`);
  }
}
export default new PkgCategoryService();
